import { createTheme, alpha } from '@mui/material/styles';

const defaultTheme = createTheme();
const customShadows = [...defaultTheme.shadows];

export const gold = {
    50: 'hsl(38, 42%, 94%)',
    100: 'hsl(38, 38%, 86%)',
    200: 'hsl(38, 36%, 74%)',
    300: 'hsl(38, 34%, 64%)',
    400: 'hsl(38, 40%, 58%)',
    500: 'hsl(38, 42%, 52%)',
    600: 'hsl(36, 38%, 42%)',
    700: 'hsl(34, 32%, 32%)',
    800: 'hsl(32, 24%, 20%)',
    900: 'hsl(30, 20%, 12%)',
};

export const gray = {
    50: 'hsl(36, 18%, 96%)',
    100: 'hsl(36, 12%, 90%)',
    200: 'hsl(32, 10%, 80%)',
    300: 'hsl(30, 8%, 64%)',
    400: 'hsl(28, 8%, 48%)',
    500: 'hsl(28, 8%, 38%)',
    600: 'hsl(28, 8%, 28%)',
    700: 'hsl(24, 8%, 18%)',
    800: 'hsl(24, 10%, 10%)',
    900: 'hsl(24, 12%, 5%)',
};

export const getDesignTokens = (mode) => {
    customShadows[1] =
        mode === 'dark'
            ? 'hsla(24, 20%, 4%, 0.55) 0px 8px 24px 0px'
            : 'hsla(24, 20%, 8%, 0.08) 0px 8px 24px 0px';

    return {
        palette: {
            mode,
            primary: {
                light: gold[200],
                main: '#c6a46a',
                dark: gold[700],
                contrastText: '#14110d',
                ...(mode === 'dark' && {
                    light: gold[200],
                    main: '#c6a46a',
                    dark: gold[600],
                    contrastText: '#14110d',
                }),
            },
            secondary: {
                light: gold[100],
                main: '#8a7a62',
                dark: gold[800],
                contrastText: '#f3efe6',
            },
            background: {
                default: '#0a0a0a',
                paper: '#141210',
                ...(mode === 'dark' && {
                    default: '#0a0a0a',
                    paper: '#141210',
                }),
            },
            text: {
                primary: '#f3efe6',
                secondary: '#9a9388',
                ...(mode === 'dark' && {
                    primary: '#f3efe6',
                    secondary: '#9a9388',
                }),
            },
            divider: alpha('#f3efe6', 0.08),
            action: {
                hover: alpha('#c6a46a', 0.08),
                selected: alpha('#c6a46a', 0.14),
            },
        },
        typography: {
            fontFamily: 'Roboto, "Barlow", "Red Hat Display", sans-serif',
            h1: {
                fontFamily: 'Barlow, Roboto, sans-serif',
                fontWeight: 700,
                fontSize: defaultTheme.typography.pxToRem(48),
                lineHeight: 1.15,
                letterSpacing: -0.8,
            },
            h2: {
                fontFamily: 'Barlow, Roboto, sans-serif',
                fontWeight: 700,
                fontSize: defaultTheme.typography.pxToRem(36),
                lineHeight: 1.2,
                letterSpacing: -0.4,
            },
            h3: {
                fontFamily: 'Barlow, Roboto, sans-serif',
                fontWeight: 700,
                fontSize: defaultTheme.typography.pxToRem(28),
                lineHeight: 1.25,
            },
            h4: {
                fontFamily: 'Roboto, "Barlow", "Red Hat Display", sans-serif',
                fontSize: defaultTheme.typography.pxToRem(22),
                fontWeight: 600,
                lineHeight: 1.4,
            },
            h5: {
                fontFamily: 'Roboto, "Barlow", "Red Hat Display", sans-serif',
                fontSize: defaultTheme.typography.pxToRem(18),
                fontWeight: 600,
            },
            h6: {
                fontFamily: 'Roboto, "Barlow", "Red Hat Display", sans-serif',
                fontSize: defaultTheme.typography.pxToRem(16),
                fontWeight: 600,
            },
            subtitle1: {
                fontSize: defaultTheme.typography.pxToRem(18),
            },
            subtitle2: {
                fontSize: defaultTheme.typography.pxToRem(16),
                fontWeight: 500,
            },
            body1: {
                fontSize: defaultTheme.typography.pxToRem(17),
            },
            body2: {
                fontSize: defaultTheme.typography.pxToRem(15),
                fontWeight: 400,
            },
            caption: {
                fontSize: defaultTheme.typography.pxToRem(13),
                fontWeight: 400,
            },
        },
        shape: {
            borderRadius: 12,
        },
        zIndex: {
            appBar: 80,
            modal: 2000,
        },
        shadows: customShadows,
    };
};

export const theme = (mode) => createTheme(getDesignTokens(mode));
